import { makeActionCreator } from '../../config/store/utils'
import { createComparatorBiddings } from '../../services/comparatorCharts'
import Unique, { inverse } from '../../modules/utils/arrays'
import theme from '../../config/styles/theme'

export const COMPARATORBIDDINGS = 'COMPARATORBIDDINGS'
export const COMPARATORBIDDINGS_SUCCESS = 'COMPARATORBIDDINGS_SUCCESS'
export const COMPARATORBIDDINGS_ERROR = 'COMPARATORBIDDINGS_ERROR'
export const onComparatorBiddings = makeActionCreator(COMPARATORBIDDINGS)
export const onComparatorBiddingsSuccess = makeActionCreator(COMPARATORBIDDINGS_SUCCESS, 'payload')
export const onComparatorBiddingsError = makeActionCreator(COMPARATORBIDDINGS_ERROR, 'payload')
export const onComparatorBiddingsThunk =
  ({ year, idEntity }, type, firstName, secondName) =>
  async dispatch => {
    dispatch(onComparatorBiddings())

    try {
      const response = await createComparatorBiddings({ year, idEntity })

      if (response.data.success !== 'OK') {
        return dispatch(onComparatorBiddingsError(response.data.errores))
      }

      const firstEntity = response.data.payload[0].data1
      const secondEntity = response.data.payload[0].data2
      // Categories
      const firstCategories = firstEntity.map(category => category.name)
      const secondCategories = secondEntity.map(category => category.name)
      const allCategories = Unique(firstCategories.concat(secondCategories))
      const ObjCategories = inverse(Object.assign({}, allCategories))
      const sortedFirstEntity = firstEntity.sort((a, b) => ObjCategories[a.name] - ObjCategories[b.name])
      const sortedSecondEntity = secondEntity.sort((a, b) => ObjCategories[a.name] - ObjCategories[b.name])

      allCategories.map((category, index) =>
        !sortedFirstEntity.some(item => item.name === category)
          ? sortedFirstEntity.splice(index, 0, { name: category, amount: 0, quantityBiddings: 0, quantityOrders: 0 })
          : null
      )
      allCategories.map((category, index) =>
        !sortedSecondEntity.some(item => item.name === category)
          ? sortedSecondEntity.splice(index, 0, { name: category, amount: 0, quantityBiddings: 0, quantityOrders: 0 })
          : null
      )

      // Amounts
      const firstAmountData = {
        name: firstName,
        data: firstEntity.map(item => item.amount || 0),
        color: theme.palette.charts.navyBlue
      }
      const secondAmountData = {
        name: secondName,
        data: secondEntity.map(item => item.amount || 0),
        color: theme.palette.charts.darkRed
      }
      // Biddings
      const firstBiddingsData = {
        name: firstName,
        data: firstEntity.map(item => item.quantiyBiddings || 0),
        color: theme.palette.charts.navyBlue
      }
      const secondBiddingsData = {
        name: secondName,
        data: secondEntity.map(item => item.quantiyBiddings || 0),
        color: theme.palette.charts.darkRed
      }

      // Orders
      const firstOrdersData = {
        name: firstName,
        data: firstEntity.map(item => item.quantityOrders || 0),
        color: theme.palette.charts.navyBlue
      }
      const secondOrdersData = {
        name: secondName,
        data: secondEntity.map(item => item.quantityOrders || 0),
        color: theme.palette.charts.darkRed
      }
      // Percentages
      const firstPercentagesData = {
        name: firstName,
        data: firstEntity.map(item => item.percentage || 0),
        color: theme.palette.charts.navyBlue
      }
      const secondPercentagesData = {
        name: secondName,
        data: secondEntity.map(item => item.percentage || 0),
        color: theme.palette.charts.darkRed
      }
      // CSV
      const firstArray = firstEntity.map(item => [
        firstName,
        year,
        item.name,
        item.quantityOrders,
        item.quantiyBiddings,
        item.amount,
        item.percentage
      ])
      const secondArray = secondEntity.map(item => [
        secondName,
        year,
        item.name,
        item.quantityOrders,
        item.quantiyBiddings,
        item.amount,
        item.percentage
      ])
      const dataByTypes = {
        amount: [firstAmountData, secondAmountData],
        lic: [firstBiddingsData, secondBiddingsData],
        oc: [firstOrdersData, secondOrdersData],
        percentage: [firstPercentagesData, secondPercentagesData]
      }
      const payload = {
        categories: allCategories,
        chart: dataByTypes[type],
        csvStructure: [
          [
            'Organismo comprador',
            'Año',
            'Categoría Licitación',
            'N° órdenes de compra',
            'N° licitaciones',
            'Monto total transado (CLP)',
            'Monto porcentual'
          ],
          ...[...firstArray, ...secondArray].map(item => item.map(subitem => subitem ?? 0))
        ]
      }

      return dispatch(onComparatorBiddingsSuccess(payload))
    } catch (error) {
      return dispatch(onComparatorBiddingsError(error))
    }
  }
